// Bölüm 1 sonu: lokasyona atanmış "Çalışmaya Bağlı Özel Durumlar" — her durum için Evet/Hayır zorunlu
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Siren } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SituationRow = ({ s, answer, onAnswer }) => {
  const answered = answer === true || answer === false;
  return (
    <div className={`flex flex-wrap items-center justify-between gap-3 rounded-lg border-2 p-3 transition-colors ${answer === true ? 'border-amber-400 bg-amber-100/60' : answered ? 'border-slate-200 bg-white' : 'border-amber-200 bg-white'}`}
      data-guide-required={answered ? undefined : 'true'} data-testid={`special-situation-option-${s.id}`}>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium text-slate-800">{s.title}</p>
        {s.description && <p className="text-xs text-slate-500">{s.description}</p>}
        {!answered && <p className="missing-hint mt-0.5 text-[11px] font-medium text-amber-700">Evet veya Hayır seçin</p>}
      </div>
      <div className="flex gap-2">
        {[[true, 'Evet'], [false, 'Hayır']].map(([v, l]) => (
          <button key={l} type="button" onClick={() => onAnswer(v)} data-testid={`special-situation-${v ? 'yes' : 'no'}-${s.id}`}
            className={`h-9 rounded-lg border px-5 text-sm font-semibold transition-colors ${answer === v ? (v ? 'border-amber-600 bg-amber-600 text-white' : 'border-slate-700 bg-slate-700 text-white') : 'border-slate-300 bg-white text-slate-700 hover:bg-slate-100'}`}>{l}</button>
        ))}
      </div>
    </div>
  );
};

export const SpecialSituationsQuestion = ({ formData, set, onDoneChange }) => {
  const [items, setItems] = useState(null);
  const locationId = formData.location_id;
  const answers = formData.special_situation_answers || {};

  useEffect(() => {
    if (!locationId) { setItems([]); return; }
    let alive = true;
    axios.get(`${API}/special-situations/location/${locationId}`).then(r => {
      if (!alive) return;
      setItems(r.data);
      const valid = new Set(r.data.map(s => s.id));
      const cur = formData.special_situation_ids || [];
      const ans = formData.special_situation_answers || {};
      if (cur.some(id => !valid.has(id)) || Object.keys(ans).some(id => !valid.has(id))) {
        set({ special_situation_ids: cur.filter(id => valid.has(id)), special_situation_answers: Object.fromEntries(Object.entries(ans).filter(([id]) => valid.has(id))) });
      }
    }).catch(() => alive && setItems([]));
    return () => { alive = false; };
  }, [locationId]);

  const done = items !== null && items.every(s => typeof answers[s.id] === 'boolean');
  useEffect(() => { onDoneChange?.(done); }, [done]);
  useEffect(() => () => onDoneChange?.(false), []);

  if (!items?.length) return null;
  const answer = (id, v) => {
    const next = { ...answers, [id]: v };
    set({ special_situation_answers: next, special_situation_ids: items.filter(s => next[s.id] === true).map(s => s.id) });
  };

  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50/40 p-4 space-y-3 animate-in fade-in slide-in-from-top-2" data-testid="wizard-special-situations">
      <div>
        <p className="font-medium text-slate-800 flex items-center gap-2"><Siren className="h-4 w-4 text-amber-600" />Çalışmaya Bağlı Özel Durumlar <span className="text-xs font-semibold text-rose-600">*</span></p>
        <p className="text-xs text-slate-600 mt-1">Çalışma öncesinde, boyunca veya sonrasında aşağıdaki durumların oluşma ihtimali var mı? Her biri için Evet veya Hayır seçin.</p>
      </div>
      <div className="space-y-2">
        {items.map(s => <SituationRow key={s.id} s={s} answer={answers[s.id]} onAnswer={(v) => answer(s.id, v)} />)}
      </div>
    </div>
  );
};

export const situationsText = (list) => (list?.length ? list.map(s => s.title).join(', ') : 'Çalışmaya bağlı özel durum belirtilmemiştir');
